// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ji1E","productName":"Table_productName__1gFHB"};